import { render, staticRenderFns } from "./MarketingLeads.vue?vue&type=template&id=544c6c6a&lang=pug"
import script from "./MarketingLeads.vue?vue&type=script&lang=js"
export * from "./MarketingLeads.vue?vue&type=script&lang=js"
import style0 from "./MarketingLeads.vue?vue&type=style&index=0&id=544c6c6a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports